"use strict";

if (document.querySelector('.mySwiper')) {
  var ambassadorsSwiper = [];
  document.querySelectorAll('.mySwiper').forEach(function (item, index) {
    var slider = item;
    var speed = slider.dataset.speed;
    var swiper = new Swiper(slider, {
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      slidesPerView: 1,
      spaceBetween: 37,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        575: {
          slidesPerView: 2,
          loopedSlides: 4
        },
        768: {
          slidesPerView: 3,
          loopedSlides: 6
        },
        992: {
          slidesPerView: 4,
          loopedSlides: 8
        }
      },
      autoplay: {
        delay: speed ? speed : '7000'
      },
      pagination: false
    });
  });
}